// extracted by mini-css-extract-plugin
export default {"column":"column_column__MX0EZ"};